"use client"

import {
  Popover
} from "antd";
import {
  HelpCircle
} from "lucide-react";
import React, {
  useState
} from "react";

interface HelpIconProps {
  tooltipText?: string
  className?: string
  iconSize?: number
}


export const HelpIcon: React.FC<HelpIconProps> = ({
  tooltipText = "Est. arrival time, actual date may vary.",
  className = "",
  iconSize = 16
}) => {
  const [clicked, setClicked] = useState(false);
  const [hovered, setHovered] = useState(false);

  const hide = () => {
    setClicked(false);
    setHovered(false);
  };

  const handleHoverChange = (open: boolean) => {
    setHovered(open);
    setClicked(false);
  };

  const handleClickChange = (open: boolean) => {
    setHovered(false);
    setClicked(open);
  };

  const hoverContent = <div>{tooltipText}</div>;
  const clickContent = <div>{tooltipText}</div>;
  
  return (
    <Popover
      style={{
        width: 500 
      }}
      content={hoverContent}
      trigger='hover'
      open={hovered}
      onOpenChange={handleHoverChange}
      className={className}
    >
      <Popover
        content={
          <div>
            {clickContent}
          </div>
        }
        trigger='click'
        open={clicked}
        onOpenChange={handleClickChange}
      >
        <HelpCircle 
          size={iconSize} 
          className='hover_text-primary active_text-primary cursor-pointer text-gray-400 transition-colors' 
        />
      </Popover>
    </Popover>
  );
};

